import * as React from 'react';
import { IMaskInput } from 'react-imask';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const TextMaskPhone = React.forwardRef<HTMLElement, CustomProps>(function TextMaskPhone(props: any, ref) {
  const { onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask="(AA)9B000-0000"
      definitions={{
        A: /[1-9]/,
        B: /[1-9]/,
        '0': /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});
